export const LMT_ENHCMT_setGlobalOverlayLoaderReducer = {
  LMT_ENHCMT_setGlobalOverlayLoader: (state, action) => {
    state.globalOverlayLoader = action.payload;
  },
};
